const MOBILE_SCREEN_WIDTH = 721;
const REGEX = /reverb.*ios|android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;

export default {
  userAgent() {
    return navigator.userAgent;
  },

  isMobileBrowser() {
    return REGEX.test(this.userAgent());
  },

  getClickEvent() {
    return this.isMobileBrowser() ? 'touchend' : 'click';
  },

  isMobileScreenWidth() {
    return window.screen.width < MOBILE_SCREEN_WIDTH;
  },
};



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/reverb-js-common/mobile_detection.js